import React, { useState, useEffect, memo } from 'react';
import json from '../../Auditoria/index.json';
import { Objeto } from '../../../../Services/Models';
import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs } from '@syncfusion/ej2-react-grids'
import { Button, Card, FormGroup, Elevation, H2, InputGroup, Icon, MenuItem, ButtonGroup } from '@blueprintjs/core';
import { Select, MultiSelect } from "@blueprintjs/select";
import moment from 'moment';
import {
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  GridComponent,
  Page,
  Inject,
  Filter,
  Group,
  ExcelExport,
  PdfExport,
  Toolbar,
  ToolbarItems,
  Grid,
  FilterSettingsModel,
  Sort,
  Resize
} from '@syncfusion/ej2-react-grids';
import './style.css'
import { Identificador } from '../../../../Services/Controllers';

L10n.load(json)
loadCldr(
  require('../../../../../node_modules/cldr-data/main/pt/currencies.json'),
  require('../../../../../node_modules/cldr-data/main/pt/numbers.json'),
  require('../../../../../node_modules/cldr-data/main/pt/numbers.json'),
  require('../../../../../node_modules/cldr-data/main/pt/ca-gregorian.json'),
  require('../../../../../node_modules/cldr-data/main/pt/timeZoneNames.json'),
  require('../../../../../node_modules/cldr-data/supplemental/numberingSystems.json'));
setCulture('pt');
setCurrencyCode("BRL");

function App({ vendasNoTempo }: any) {
  const [getProjectData, setProjectData] = useState();
  const [getData, setData] = useState<Array<Objeto.VendaNoTempo>>([]);
  const [getTextoProcurado, setTextoProcurado] = useState<string>("");
  const [getItemPickerCentroDeCusto, setItemPickerCentroDeCusto] = useState<{ id: number, descricao: string }>();
  const [getListaPickerCentroDeCusto, setListaPickerCentroDeCusto] = useState<Array<{ id: number, descricao: string }>>([
    {
      id: 1,
      descricao: "Vendas sem cessão"
    },
    {
      id: 2,
      descricao: "Vendas de cessão"
    },
    {
      id: 3,
      descricao: "Vendas distratadas"
    },
    {
      id: 4,
      descricao: "Depósitos"
    }
  ]);
  const PickerCentroDeCusto = Select.ofType<{ id: number, descricao: string }>();
  const [getPricipal, setPrincipal] = useState<number>();
  let preTotalValue: number = 0;
  let preData: Array<Objeto.VendaNoTempo> = [];
  const filterOptions: FilterSettingsModel = {
    ignoreAccent: true,
    immediateModeDelay: 200,
    mode: "Immediate",
    type: 'Excel'
  }
  let sum: number = 0;
  let grid: Grid | null;
  const toolbarOptions: ToolbarItems[] = ['PdfExport', 'CsvExport']
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs | any) => {
    args.cell.cellHeight = 10;
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(2).textAlign = "Right";
  }
  const toolbarClick = (args: any) => {
    console.log('pre-grid')
    if (grid) {
      console.log(args.item.id)
      if (args.item.id === 'grid_pdfexport') {
        grid.pdfExport({
          fileName: `Vendas No Tempo ${moment(new Date(), true).format("YYYY-MM-DD")}.pdf`,
          pageOrientation: "Landscape",
          header: {
            fromTop: 0,
            height: 130,
            contents: [
              // {
              //   type: 'Text',
              //   value: `${getItemPickerCentroDeCusto?.descricao}`,
              //   position: { x: 390, y: 50 },
              //   style: { textBrushColor: "#000000", fontSize: 20, hAlign: "Right" },
              // },
              // {
              //   position: { x: 0, y: 45 },
              //   size: { height: 40, width: 80 },
              //   src: image,
              //   type: 'Image',
              // },
              {
                type: 'Text',
                value: `${moment(new Date(), true).format("DD/MM/YYYY HH:mm:ss")}`,
                position: { x: 880, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 13 },
              },
            ]
          },
          footer: {
            contents: [
              {
                type: 'Text',
                value: `Powered by DigitalDEV`,
                position: { x: 0, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 10 },
              },
              {
                format: 'Página {$current} de {$total}',
                pageNumberType: "Numeric",
                position: { x: 910, y: 50 },
                style: {
                  fontSize: 13,
                  hAlign: "Right",
                  textBrushColor: '#000000',
                },
                type: 'PageNumber',
              }
            ],
            fromBottom: 0,
            height: 100,
          },
          theme: {
            header: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            },
            record: {
              bold: false,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7)
            },
            caption: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            }
          },
          allowHorizontalOverflow: false,

        });
      }
      if (args.item.id === 'grid_excelexport') {
        grid.excelExport({
          dataSource: getData
        })
      }
      if (args.item.id === 'grid_csvexport') {
        grid.getColumnByField('Valor_ven').format = "N2"
        grid.getColumnByField('VlrPrincipal_Prc').format = "N2"
        grid.getColumnByField('VlrCorrecao').format = "N2"
        grid.getColumnByField('VlrJuros').format = "N2"
        grid.getColumnByField('VlrJurosAtraso').format = "N2"
        grid.getColumnByField('ValorPrincipalCurto').format = "N2"
        grid.getColumnByField('ValorPrincipalLongo').format = "N2"
        grid.getColumnByField('ValorCorrecaoCurto').format = "N2"
        grid.getColumnByField('ValorCorrecaoLongo').format = "N2"
        grid.getColumnByField('ValorJurosCurto').format = "N2"
        grid.getColumnByField('ValorJurosLongo').format = "N2"
        grid.getColumnByField('Total').format = "N2"
        grid.csvExport({
          dataSource: getData
        })
      }
    }
  }

  useEffect(() => {
    async function componentDidMount() {
      if (vendasNoTempo) {
        await vendasNoTempo.map((objeto: Objeto.VendaNoTempo, index: number) => {
          preData.push(
            {
              DataVisao: moment(objeto.DataVisao).subtract('10', 'days').endOf("month").format('DD/MM/YYYY'),
              KEY_CDEMP_BD: objeto.KEY_CDEMP_BD,
              KEY_CDEMP_CDOBR_BD: objeto.KEY_CDEMP_CDOBR_BD,
              KEY_CDEMP_CDOBR_NUMVEN_BD: objeto.KEY_CDEMP_CDOBR_NUMVEN_BD,
              Status_Visao: objeto.Status_Visao,
              Status_Atual: objeto.Status_Atual,
              Empresa_prc: objeto.Empresa_prc,
              NM_EMPRESA: objeto.NM_EMPRESA,
              NM_OBRA: objeto.NM_OBRA,
              Identificador_prc: objeto.Identificador_prc,
              Obra_Prc: objeto.Obra_Prc,
              DataVen_prc: objeto.DataVen_prc === "" ? "" : moment(objeto.DataVen_prc).add('1', 'days').format('DD/MM/YYYY'),
              DataCancel_prc: objeto.DataCancel_prc === "" ? "" : moment(objeto.DataCancel_prc).add('1', 'days').format('DD/MM/YYYY'),
              DataRec_Prc: objeto.DataRec_Prc === "" ? "" : moment(objeto.DataRec_Prc).add('1', 'days').format('DD/MM/YYYY'),
              DataDep_Prc: objeto.DataDep_Prc === "" ? "" : moment(objeto.DataDep_Prc).add('1', 'days').format('DD/MM/YYYY'),
              NumVend_prc: objeto.NumVend_prc,
              nome_pes: objeto.nome_pes,
              Tipo_Prc: objeto.Tipo_Prc,
              NumParc_Prc: objeto.NumParc_Prc,
              NumParcGer_Prc: objeto.NumParcGer_Prc,
              Data_Prc: objeto.Data_Prc === "" ? "" : moment(objeto.Data_Prc).add('1', 'days').format('DD/MM/YYYY'),
              VlrPrincipal_Prc: objeto.VlrPrincipal_Prc,
              VlrCorrecao: objeto.VlrCorrecao,
              VlrJuros: objeto.VlrJuros,
              VlrJurosAtraso: objeto.VlrJurosAtraso,
              ValorPrincipalCurto: objeto.ValorPrincipalCurto,
              ValorPrincipalLongo: objeto.ValorPrincipalLongo,
              ValorCorrecaoCurto: objeto.ValorCorrecaoCurto,
              ValorCorrecaoLongo: objeto.ValorCorrecaoLongo,
              ValorJurosCurto: objeto.ValorJurosCurto,
              ValorJurosLongo: objeto.ValorJurosLongo,
              ContratoFinan: objeto.ContratoFinan,
              ContratoCEF_ven: objeto.ContratoCEF_ven,
              Valor_ven: Number(objeto.Valor_ven),
              Status_ven: objeto.Status_ven,
              Data_doc: objeto.Data_doc === "" ? "" : moment(objeto.Data_doc).format('DD/MM/YYYY'),
              Banco_doc: objeto.Banco_doc,
              Conta_doc: objeto.Conta_doc,
              DataAssinatura_vfi: objeto.DataAssinatura_vfi === "" ? "" : moment(objeto.DataAssinatura_vfi).add("1", "day").format('DD/MM/YYYY'),
              Total: objeto.VlrPrincipal_Prc + objeto.VlrCorrecao + objeto.VlrJuros
            }
          )
        })
      }
      await setData(preData)
      console.log(preData)
    }

    componentDidMount();
  }, [vendasNoTempo])

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <GridComponent
          dataSource={getData}
          id='grid'
          allowSorting={true}
          allowMultiSorting={true}
          ref={g => grid = g}
          allowPaging={true}
          allowFiltering={true}
          pageSettings={{ pageSizes: [10, 20, 30], pageSize: 15 }}
          filterSettings={filterOptions}
          toolbarClick={toolbarClick}
          toolbar={toolbarOptions}
          pdfQueryCellInfo={pdfQueryCellInfo}
          pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
          actionBegin={
            (args: any) => {
              if (args.requestType === "filterchoicerequest" || args.requestType === 'filtersearchbegin') {
                args.filterChoiceCount = 1000000;
              }
            }
          }
          allowPdfExport={true}
          allowResizing={true}
          allowExcelExport={true}>
          <ColumnsDirective>
            <ColumnDirective field='DataVisao' headerText='DataVisao' width='155px' />
            <ColumnDirective field='NM_EMPRESA' headerText='NM_EMPRESA' width='200px' />
            <ColumnDirective field='NM_OBRA' headerText='NM_OBRA' width='182px' />
            <ColumnDirective field='DataVen_prc' headerText='DtVenda' width='180px' />
            <ColumnDirective field='DataCancel_prc' headerText='DtCancelamento' width='190px' />
            <ColumnDirective field='Identificador_prc' headerText='Unidade' width='200px' />
            <ColumnDirective field='DataRec_Prc' headerText='DtRecebimento' width='200px' />
            <ColumnDirective field='DataDep_Prc' headerText='DtDepósito' width='180px' />
            <ColumnDirective field='Status_Visao' headerText='Status Visao' width='180px' />
            <ColumnDirective field='Status_Atual' headerText='Status Atual' width='180px' />
            <ColumnDirective field='NumVend_prc' headerText='Número Venda' format="N0" width='180px' />
            <ColumnDirective field='nome_pes' headerText='Cliente' format="N0" width='180px' />
            <ColumnDirective field='Status_ven' headerText='Status_ven' format="N0" width='180px' />
            <ColumnDirective field='ContratoFinan' headerText='ContratoFinan' width='200px' />
            <ColumnDirective field='ContratoCEF_ven' headerText='ContratoCEF_ven' width='200px' />
            <ColumnDirective field='DataAssinatura_vfi' headerText='Data Assinatura' width='200px' />
            <ColumnDirective field='Valor_ven' headerText='Valor_ven' format="C2" width='200px' />
            <ColumnDirective field='Tipo_Prc' headerText='Tipo Parcela' width='180px' />
            <ColumnDirective field='NumParc_Prc' headerText='Número Parcela' format="N0" width='180px' />
            <ColumnDirective field='Data_Prc' headerText='Vencimento' width='180px' />
            <ColumnDirective field='VlrPrincipal_Prc' headerText='Valor Principal' format="C2" width='200px' />
            <ColumnDirective field='VlrCorrecao' headerText='Valor Correção' format="C2" width='200px' />
            <ColumnDirective field='VlrJuros' headerText='Valor Juros(Correção)' format="C2" width='200px' />
            <ColumnDirective field='VlrJurosAtraso' headerText='Valor Juros(Atraso)' format="C2" width='200px' />
            <ColumnDirective field='ValorPrincipalCurto' headerText='Valor Principal(Curto)' format="C2" width='200px' />
            <ColumnDirective field='ValorPrincipalLongo' headerText='Valor Principal(Longo)' format="C2" width='200px' />
            <ColumnDirective field='ValorCorrecaoCurto' headerText='Valor Correção(Curto)' format="C2" width='200px' />
            <ColumnDirective field='ValorCorrecaoLongo' headerText='Valor Correção(Longo)' format="C2" width='200px' />
            <ColumnDirective field='ValorJurosCurto' headerText='Valor Juros(Curto)' format="C2" width='200px' />
            <ColumnDirective field='ValorJurosLongo' headerText='Valor Juros(Longo)' format="C2" width='200px' />
            <ColumnDirective field='Data_doc' headerText='Data de Compensação' width='200px' />
            <ColumnDirective field='Banco_doc' headerText='Banco_doc' width='200px' />
            <ColumnDirective field='Conta_doc' headerText='Conta_doc' width='200px' />
            <ColumnDirective field='Total' headerText='Total' format="C2" width='180px' />
          </ColumnsDirective>
          <AggregatesDirective>
            <AggregateDirective>
              <AggregateColumnsDirective>
                <AggregateColumnDirective field="VlrPrincipal_Prc" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="VlrCorrecao" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="VlrJuros" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="VlrJurosAtraso" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorPrincipalCurto" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorPrincipalLongo" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorCorrecaoCurto" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorCorrecaoLongo" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorJurosCurto" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorJurosLongo" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="Total" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
              </AggregateColumnsDirective>
            </AggregateDirective>
          </AggregatesDirective>
          <Inject services={[Page, Filter, Group, ExcelExport, PdfExport, ExcelExport, Toolbar, Aggregate, Sort, Resize]} />
        </GridComponent>
      </div>
    </>
  );
}

export default memo(App);